module.exports = __webpack_public_path__ + "img/bt.1bde2de6.svg";